<nav class="breadcrumbs">
  <section *ngFor="let crumb of breadCrumbs; let first = first"
           class="breadcrumbs-block">
    <span *ngIf="!first" class="breadcrumbs-separator">/</span>
    <a class="breadcrumbs-link"
       [class.first]="first"
       [routerLink]="crumb.routerLink"
       [routerLinkActiveOptions]="{exact: true}"
       routerLinkActive="active">
      {{ crumb.title | async }}
    </a>
  </section>
</nav>
